import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { DirectivesModule } from '../shared/directives/directives.module';
import { SharedModule } from '../shared/shared.module';
import { AuthorizedLayoutComponent } from './authorized-layout/authorized-layout.component';
import { FooterComponent } from './authorized-layout/footer/footer.component';
import { HeaderElementsComponent } from './authorized-layout/header-elements/header-elements.component';
import { NotificationPanelComponent } from './authorized-layout/header-elements/pages/notification-panel/notification-panel.component';
import { HeaderComponent } from './authorized-layout/header/header.component';
import { MobileHeaderComponent } from './authorized-layout/mobile-header/mobile-header.component';
import { SidebarComponent } from './authorized-layout/sidebar/sidebar.component';
import { TopnavComponent } from './authorized-layout/topnav/topnav.component';
import { UnauthorizedLayoutComponent } from './unauthorized-layout/unauthorized-layout.component';

@NgModule({
  declarations: [
    UnauthorizedLayoutComponent,
    AuthorizedLayoutComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    HeaderElementsComponent,
    TopnavComponent,
    MobileHeaderComponent,
    NotificationPanelComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    DirectivesModule,
    MatDialogModule,
    MatButtonModule,
    CommonModule,
    MatIconModule,
    MatSidenavModule,
    MatInputModule,
    MatMenuModule,
    InfiniteScrollDirective
  ],
  providers: []
})
export class LayoutModule {}
